const Port = (() => {
  const localport = ':3200';
  const fairport = ':8484';
  // const globelport = ':1337';
  // const globelport = ':8484';
  // const globelport = ':6856'; //running port
  const globelport = ':1339'; //running port

  // const globelport = ':1580';
  const smartsearchip = ':4044';
  return { localport, fairport, globelport, smartsearchip }; // Expose these variables
})();
export default Port;
